import { render } from "./Landing.vue?vue&type=template&id=2b6edabf&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "../../../assets/css/landing.css?vue&type=style&index=0&id=2b6edabf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b6edabf"

export default script